// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2bsLD","description":"PatientConsentPreview_description__2yYGV"};